export const MODERN_SURFACE_CLASS = 'ca-modern-surface';
export const LEGACY_SURFACE_CLASS = 'ca-legacy-surface';

const MODERN_ROUTE_PREFIXES = [
	'/bases',
	'/empresas',
	'/planos',
	'/usuarios',
	'/cupons',
	'/clientes',
	'/assinaturas',
	'/contratos',
	'/compras',
	'/perfil',
	'/suporte',
	'/pedidos/b2c',
];

const MODERN_EXACT_PATHS = ['/dashboard', '/pedidos', '/retirada/rapida', '/auditoria'];

// Base44 scopes own their whole page chrome, so the shell hides its footer there.
// Each domain registers its own prefix when its Base44 surface lands.
const BASE44_SCOPE_PREFIXES = ['/clientes', '/assinaturas', '/contratos', '/compras', '/pedidos/b2c'];
const BASE44_SCOPE_EXACT_PATHS = ['/pedidos', '/retirada/rapida'];

const normalizePathname = (pathname = '') => {
	const normalized = pathname.split('?')[0].split('#')[0].replace(/\/+$/, '');
	return normalized || '/';
};

const matchesPrefix = (normalizedPathname, prefix) =>
	normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`);

export const isModernSurfacePath = (pathname) => {
	const normalizedPathname = normalizePathname(pathname);

	if (MODERN_EXACT_PATHS.includes(normalizedPathname)) return true;

	return MODERN_ROUTE_PREFIXES.some((prefix) => matchesPrefix(normalizedPathname, prefix));
};

export const isBase44ScopePath = (pathname) => {
	const normalizedPathname = normalizePathname(pathname);
	if (BASE44_SCOPE_EXACT_PATHS.includes(normalizedPathname)) return true;

	return BASE44_SCOPE_PREFIXES.some((prefix) => matchesPrefix(normalizedPathname, prefix));
};

export const getRouteSurfaceClass = (pathname) =>
	isModernSurfacePath(pathname) ? MODERN_SURFACE_CLASS : LEGACY_SURFACE_CLASS;

export const applyRouteSurface = (pathname) => {
	if (typeof document === 'undefined') return isModernSurfacePath(pathname);

	const isModern = isModernSurfacePath(pathname);
	const root = document.documentElement;

	root.classList.toggle(MODERN_SURFACE_CLASS, isModern);
	root.classList.toggle(LEGACY_SURFACE_CLASS, !isModern);
	root.style.colorScheme = isModern ? root.dataset.theme || 'dark' : 'light';

	return isModern;
};
